/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PermissionsActionQuery } from './PermissionsActionQuery';
import {
    PermissionsActionQueryFromJSON,
    PermissionsActionQueryFromJSONTyped,
    PermissionsActionQueryToJSON,
} from './PermissionsActionQuery';

/**
 * 
 * @export
 * @interface PermissionsQuery
 */
export interface PermissionsQuery {
    /**
     * 
     * @type {Array<PermissionsActionQuery>}
     * @memberof PermissionsQuery
     */
    data: Array<PermissionsActionQuery>;
}

/**
 * Check if a given object implements the PermissionsQuery interface.
 */
export function instanceOfPermissionsQuery(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function PermissionsQueryFromJSON(json: any): PermissionsQuery {
    return PermissionsQueryFromJSONTyped(json, false);
}

export function PermissionsQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionsQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(PermissionsActionQueryFromJSON)),
    };
}

export function PermissionsQueryToJSON(value?: PermissionsQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(PermissionsActionQueryToJSON)),
    };
}

